export default ({
    NETWORK_PING: 'NETWORK_PING',
    DEVICE_ACTIVATION: 'DEVICE_ACTIVATION',
    OD_PING: 'OD_PING',
    SYNC: 'SYNC',
    APP_SYNC: 'APP_SYNC',
    RTDB_CONNECTION: 'RTDB_CONNECTION',
    RTDB_CHECK_COUNT: 'RTDB_CHECK_COUNT',
    RTDB_MENU_COUNT: 'RTDB_MENU_COUNT',
    DEVICE_STATUS: 'DEVICE_STATUS',
    OMNIVORE_STORE_STATUS: 'OMNIVORE_STORE_STATUS',
    POS_SYSTEM_STATUS: 'POS_SYSTEM_STATUS',
    DEVICE: 'DEVICE',
    PRINTER: 'PRINTER',
    OMNIVIRE_HEALTHY: 'OMNIVIRE_HEALTHY',
    POS_HEALTHY: 'POS_HEALTHY',
});
